import { render, staticRenderFns } from "./SetupSQLHarvester.vue?vue&type=template&id=8727af1e&"
import script from "./SetupSQLHarvester.vue?vue&type=script&lang=ts&"
export * from "./SetupSQLHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports